<template>
  <div class="pt-2">
    <div class="row mx-0" v-if="grandAccessPermissionView && !cameraAccessPermission">
      <div class="col-12">
        <div class="feedback-header">
          <p>Please Grant Access</p>
        </div>
      </div>
    </div>
    <div class="row mt-3 mx-0" v-if="grandAccessPermissionView && !cameraAccessPermission">
      <div class="col-12">
        <div class="panel">
          <svg width="327" height="167" viewBox="0 0 327 167" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0)">
              <path d="M191.557 0V26.8813L80 20.161V10.0805C80 4.51303 84.513 0 90.0805 0H191.557Z" fill="#95B0ED" />
              <path d="M236.92 0H221.799L216.759 40.3219L247 30.2414V10.0805C247 4.51303 242.487 0 236.92 0Z" fill="#5C2BC8" />
              <path d="M221.799 0H191.557C183.206 0 176.437 6.76972 176.437 15.1207V20.161H80V30.2414L90.0805 40.3219H236.92V15.1207C236.92 6.76972 230.15 0 221.799 0Z" fill="#4E4CD3" />
              <path d="M236.92 30.2417L196.598 98.621L236.92 167H244.48C245.872 167 247 165.872 247 164.48V30.2417H236.92Z" fill="#95B0ED" />
              <path d="M236.92 30.2417H80V164.48C80 165.872 81.1283 167 82.5201 167H236.92V156.92L216.759 98.621L236.92 40.3222V30.2417Z" fill="#ACD2F6" />
              <path d="M226.839 40.3218L206.678 98.6206L226.839 156.919H236.919V40.3218H226.839Z" fill="#C4F3FF" />
              <path d="M90.0806 40.3218H226.839V156.919H90.0806V40.3218Z" fill="white" />
              <path d="M231.88 20.161C234.663 20.161 236.92 17.9045 236.92 15.1208C236.92 12.3372 234.663 10.0806 231.88 10.0806C229.096 10.0806 226.839 12.3372 226.839 15.1208C226.839 17.9045 229.096 20.161 231.88 20.161Z" fill="#05FF77" />
              <path d="M211.718 20.161C214.502 20.161 216.758 17.9045 216.758 15.1208C216.758 12.3372 214.502 10.0806 211.718 10.0806C208.934 10.0806 206.678 12.3372 206.678 15.1208C206.678 17.9045 208.934 20.161 211.718 20.161Z" fill="#FFD06A" />
              <path d="M191.557 20.161C194.341 20.161 196.598 17.9045 196.598 15.1208C196.598 12.3372 194.341 10.0806 191.557 10.0806C188.774 10.0806 186.517 12.3372 186.517 15.1208C186.517 17.9045 188.774 20.161 191.557 20.161Z" fill="#FF545A" />
              <path
                d="M172.236 82.158H166.704V79.0391H172.236C174.861 79.0391 176.996 81.1727 176.996 83.7954V89.3315H173.877V83.7954C173.877 82.8925 173.141 82.158 172.236 82.158ZM173.881 99.6238H176.999V92.4503H173.881V99.6238ZM146.119 83.8022C146.119 82.8974 146.853 82.1614 147.756 82.1614H153.292V79.0425H147.756C145.134 79.0425 143 81.1777 143 83.8022V89.3349H146.119V83.8022ZM156.411 82.158H163.585V79.0391H156.411V82.158ZM156.411 113.035H163.585V109.916H156.411V113.035ZM146.122 108.279V102.743H143.003V108.279C143.003 110.901 145.139 113.035 147.763 113.035H153.296V109.916H147.763C146.858 109.916 146.122 109.182 146.122 108.279ZM146.119 92.4504H143V99.6239H146.119V92.4504ZM183 109.916H176.996V102.743H173.877V109.916H166.704V113.035H173.877V118.961H176.996V113.035H183V109.916Z"
                fill="url(#paint0_linear)"
              />
            </g>
            <defs>
              <linearGradient id="paint0_linear" x1="163.001" y1="79.0371" x2="163.001" y2="118.961" gradientUnits="userSpaceOnUse">
                <stop stop-color="#2AF598" />
                <stop offset="1" stop-color="#009EFD" />
              </linearGradient>
              <clipPath id="clip0">
                <rect width="167" height="167" fill="white" transform="translate(80)" />
              </clipPath>
            </defs>
          </svg>
          <div class="detail">
            <h5 class="title">To take a screenshot, please grant access to your browser.</h5>
            <p class="subtitle">No worries...you can remove permissions anytime in your browser settings.</p>
            <button class="btn btn-solid" @click="grantAccessCamera">
              <div class="icon">
                <svg width="17" height="16" viewBox="0 0 17 16" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6.5001 10.7799L3.7201 7.9999L2.77344 8.9399L6.5001 12.6666L14.5001 4.66656L13.5601 3.72656L6.5001 10.7799Z" />
                </svg>
              </div>
              Grant Access
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="row mx-0" v-if="accessPopUpView && !cameraAccessPermission">
      <div class="col-12">
        <div class="feedback-header">
          <p>Please Grant Access</p>
        </div>
      </div>
    </div>
    <div class="row mt-3 mx-0" v-if="accessPopUpView && !cameraAccessPermission">
      <div class="col-12">
        <div class="panel">
          <svg width="328" height="218" viewBox="0 0 328 218" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="84.4102" y="43.1758" width="237.625" height="163.5" rx="10" fill="white" />
            <path
              d="M92.4523 48.6137H158.023C160.961 48.6137 163.343 46.2369 163.343 43.3052C163.343 40.3736 160.961 37.9968 158.023 37.9968H92.4523C85.608 37.9968 80.0391 43.5537 80.0391 50.3832V200.432C80.0391 207.262 85.608 212.819 92.4523 212.819H314.702C321.546 212.819 327.115 207.262 327.115 200.432V137.29C327.115 134.358 324.734 131.982 321.795 131.982C318.856 131.982 316.475 134.358 316.475 137.29V200.432C316.475 201.408 315.68 202.202 314.702 202.202H92.4523C91.4741 202.202 90.679 201.408 90.679 200.432V99.0998V88.4829V50.3825C90.679 49.4071 91.4741 48.6137 92.4523 48.6137Z"
              fill="#F1F2F9"
            />
            <path
              d="M316.475 99.0998V112.855C316.475 115.787 318.856 118.163 321.795 118.163C324.734 118.163 327.115 115.787 327.115 112.855V50.3825C327.115 43.553 321.546 37.9961 314.702 37.9961H182.511C179.572 37.9961 177.191 40.3729 177.191 43.3045C177.191 46.2362 179.572 48.613 182.511 48.613H314.702C315.68 48.613 316.475 49.4071 316.475 50.3825V88.4829V99.0998Z"
              fill="#F1F2F9"
            />
            <path
              d="M289.057 71.8345C289.77 72.546 290.705 72.9023 291.64 72.9023C292.574 72.9023 293.51 72.5465 294.223 71.8345L296.144 69.9177L298.065 71.8345C298.778 72.546 299.714 72.9023 300.648 72.9023C301.583 72.9023 302.518 72.5465 303.231 71.8345C304.658 70.411 304.658 68.1029 303.231 66.6799L301.31 64.7626L303.231 62.8453C304.658 61.4218 304.658 59.1137 303.231 57.6907C301.804 56.2672 299.492 56.2672 298.065 57.6907L296.145 59.6075L294.224 57.6907C292.797 56.2672 290.484 56.2672 289.058 57.6907C287.631 59.1142 287.631 61.4223 289.058 62.8453L290.979 64.7626L289.058 66.6799C287.63 68.1029 287.63 70.411 289.057 71.8345Z"
              fill="#AFBDD1"
            />
            <path d="M111.01 72.903H136.546C139.484 72.903 141.866 70.5263 141.866 67.5946C141.866 64.6629 139.484 62.2861 136.546 62.2861H111.01C108.071 62.2861 105.69 64.6629 105.69 67.5946C105.69 70.5263 108.071 72.903 111.01 72.903Z" fill="#F1F2F9" />
            <path
              d="M298.344 91.3047C298.335 91.3047 298.327 91.3047 298.318 91.3047L111.623 92.0125C108.332 92.0252 105.676 94.4119 105.69 97.3436C105.704 100.268 108.369 102.629 111.648 102.629H111.674L298.369 101.922C301.659 101.909 304.315 99.5222 304.302 96.5905C304.287 93.6666 301.623 91.3047 298.344 91.3047Z"
              fill="#F1F2F9"
            />
            <path
              d="M298.344 108.292C298.335 108.292 298.327 108.292 298.318 108.292L111.623 109C108.332 109.013 105.676 111.399 105.69 114.331C105.704 117.255 108.369 119.617 111.648 119.617H111.674L298.369 118.909C301.659 118.896 304.315 116.509 304.302 113.578C304.287 110.653 301.623 108.292 298.344 108.292Z"
              fill="#F1F2F9"
            />
            <path
              d="M298.344 124.571C298.335 124.571 298.327 124.571 298.318 124.571L111.623 125.279C108.332 125.292 105.676 127.679 105.69 130.61C105.704 133.535 108.369 135.896 111.648 135.896H111.674L298.369 135.188C301.659 135.175 304.315 132.789 304.302 129.857C304.287 126.932 301.623 124.571 298.344 124.571Z"
              fill="#F1F2F9"
            />
            <rect x="178.75" y="164.916" width="58.1649" height="24.0649" rx="4" fill="#C2CFE0" />
            <path
              d="M196.172 176.881C196.596 176.966 196.933 177.168 197.185 177.485C197.443 177.796 197.572 178.162 197.572 178.585C197.572 179.173 197.374 179.639 196.976 179.982C196.586 180.319 196.016 180.487 195.268 180.487H192.259V173.492H195.209C195.917 173.492 196.46 173.647 196.837 173.957C197.221 174.268 197.413 174.704 197.413 175.265C197.413 175.701 197.297 176.058 197.066 176.336C196.841 176.613 196.543 176.795 196.172 176.881ZM193.659 176.425H194.921C195.272 176.425 195.536 176.349 195.715 176.197C195.9 176.038 195.993 175.814 195.993 175.523C195.993 175.232 195.904 175.008 195.725 174.849C195.546 174.691 195.272 174.611 194.901 174.611H193.659V176.425ZM194.99 179.348C195.361 179.348 195.646 179.269 195.844 179.11C196.043 178.945 196.142 178.707 196.142 178.397C196.142 178.086 196.04 177.848 195.834 177.683C195.636 177.511 195.351 177.426 194.98 177.426H193.659V179.348H194.99Z"
              fill="#8997B1"
            />
            <path d="M200.053 179.417H202.406V180.487H198.652V173.492H200.053V179.417Z" fill="#8997B1" />
            <path
              d="M206.626 173.393C207.281 173.393 207.874 173.545 208.403 173.848C208.94 174.152 209.36 174.578 209.665 175.127C209.976 175.668 210.131 176.283 210.131 176.97C210.131 177.657 209.976 178.274 209.665 178.823C209.36 179.371 208.94 179.797 208.403 180.101C207.874 180.405 207.281 180.557 206.626 180.557C205.97 180.557 205.375 180.405 204.838 180.101C204.309 179.797 203.888 179.371 203.577 178.823C203.273 178.274 203.12 177.657 203.12 176.97C203.12 176.283 203.273 175.668 203.577 175.127C203.888 174.578 204.309 174.152 204.838 173.848C205.375 173.545 205.97 173.393 206.626 173.393ZM206.626 174.681C206.215 174.681 205.855 174.773 205.543 174.958C205.232 175.143 204.987 175.411 204.809 175.761C204.636 176.104 204.55 176.507 204.55 176.97C204.55 177.432 204.636 177.838 204.809 178.189C204.987 178.532 205.232 178.796 205.543 178.981C205.855 179.166 206.215 179.259 206.626 179.259C207.036 179.259 207.397 179.166 207.708 178.981C208.019 178.796 208.261 178.532 208.433 178.189C208.612 177.838 208.701 177.432 208.701 176.97C208.701 176.507 208.612 176.104 208.433 175.761C208.261 175.411 208.019 175.143 207.708 174.958C207.397 174.773 207.036 174.681 206.626 174.681Z"
              fill="#8997B1"
            />
            <path
              d="M214.452 173.422C215.325 173.422 216.05 173.647 216.626 174.096C217.202 174.545 217.583 175.156 217.768 175.929H216.299C216.146 175.553 215.908 175.255 215.584 175.037C215.266 174.819 214.882 174.71 214.432 174.71C214.061 174.71 213.727 174.803 213.429 174.988C213.131 175.173 212.899 175.437 212.734 175.781C212.568 176.124 212.485 176.527 212.485 176.99C212.485 177.445 212.568 177.845 212.734 178.189C212.899 178.532 213.131 178.796 213.429 178.981C213.727 179.166 214.061 179.259 214.432 179.259C214.882 179.259 215.266 179.15 215.584 178.932C215.908 178.714 216.146 178.416 216.299 178.04H217.768C217.583 178.813 217.202 179.424 216.626 179.873C216.05 180.322 215.325 180.547 214.452 180.547C213.783 180.547 213.19 180.398 212.674 180.101C212.164 179.797 211.767 179.374 211.482 178.833C211.204 178.291 211.065 177.677 211.065 176.99C211.065 176.296 211.204 175.678 211.482 175.137C211.767 174.595 212.164 174.175 212.674 173.878C213.184 173.574 213.776 173.422 214.452 173.422Z"
              fill="#8997B1"
            />
            <path d="M221.639 176.93L224.608 180.487H222.91L220.318 177.287V180.487H218.918V173.492H220.318V176.633L222.92 173.492H224.608L221.639 176.93Z" fill="#8997B1" />
            <rect x="245.009" y="165.916" width="56.1648" height="22.0649" rx="3" fill="#B4E0FF" stroke="#0383FF" stroke-width="2" />
            <path d="M261.07 179.08H258.26L257.763 180.487H256.284L258.866 173.571H260.464L263.036 180.487H261.557L261.07 179.08ZM260.693 178.02L259.66 175.067L258.627 178.02H260.693Z" fill="#0383FF" />
            <path d="M265.292 179.417H267.645V180.487H263.892V173.492H265.292V179.417Z" fill="#0383FF" />
            <path d="M269.978 179.417H272.332V180.487H268.578V173.492H269.978V179.417Z" fill="#0383FF" />
            <path
              d="M276.551 173.393C277.207 173.393 277.799 173.545 278.329 173.848C278.865 174.152 279.286 174.578 279.59 175.127C279.901 175.668 280.057 176.283 280.057 176.97C280.057 177.657 279.901 178.274 279.59 178.823C279.286 179.371 278.865 179.797 278.329 180.101C277.799 180.405 277.207 180.557 276.551 180.557C275.896 180.557 275.3 180.405 274.764 180.101C274.234 179.797 273.814 179.371 273.503 178.823C273.198 178.274 273.046 177.657 273.046 176.97C273.046 176.283 273.198 175.668 273.503 175.127C273.814 174.578 274.234 174.152 274.764 173.848C275.3 173.545 275.896 173.393 276.551 173.393ZM276.551 174.681C276.141 174.681 275.78 174.773 275.469 174.958C275.158 175.143 274.913 175.411 274.734 175.761C274.562 176.104 274.476 176.507 274.476 176.97C274.476 177.432 274.562 177.838 274.734 178.189C274.913 178.532 275.158 178.796 275.469 178.981C275.78 179.166 276.141 179.259 276.551 179.259C276.962 179.259 277.323 179.166 277.634 178.981C277.945 178.796 278.187 178.532 278.359 178.189C278.537 177.838 278.627 177.432 278.627 176.97C278.627 176.507 278.537 176.104 278.359 175.761C278.187 175.411 277.945 175.143 277.634 174.958C277.323 174.773 276.962 174.681 276.551 174.681Z"
              fill="#0383FF"
            />
            <path d="M290.405 173.492L288.687 180.487H286.959L285.648 175.414L284.327 180.487H282.609L280.891 173.492H282.411L283.483 178.912L284.874 173.492H286.413L287.813 178.912L288.885 173.492H290.405Z" fill="#0383FF" />
            <path
              d="M302.01 190.595L291.764 180.607C291.389 180.316 290.824 180.594 290.824 181.028V194.678C290.824 194.983 291.078 195.231 291.392 195.231C291.539 195.231 291.681 195.176 291.762 195.096L294.601 192.684L296.916 197.959C296.955 198.049 297.029 198.119 297.122 198.156C297.168 198.173 297.215 198.182 297.263 198.182C297.314 198.182 297.364 198.172 297.412 198.152L299.848 197.134C300.041 197.054 300.13 196.837 300.047 196.65L297.806 191.542H301.606C301.919 191.542 302.173 191.294 302.173 190.989C302.173 190.899 302.15 190.765 302.01 190.595Z"
              fill="#252733"
            />
            <path
              d="M140.136 93.4413L50.0836 25.0526L64.3057 21.3125C68.6283 20.1675 65.1263 13.7358 59.9869 13.3627L8.28863 9.64178C5.49587 9.44322 4.15237 11.4949 5.45733 13.9654L29.6321 59.7172C32.0311 64.275 39.3449 64.8795 38.6555 60.4825L36.4015 45.9839L135.31 100.811C142.399 104.756 146.607 98.3364 140.136 93.4413Z"
              fill="#FF077B"
            />
          </svg>
          <div class="detail">
            <h5 class="title mb-0">Please click the “Allow” button in the popup window to enable permissions.</h5>
          </div>
        </div>
      </div>
    </div>
    <div class="row mx-0" v-if="recordScreenHelpView">
      <div class="col-12">
        <div class="feedback-header">
          <p>How To Screenshot:</p>
        </div>
      </div>
    </div>
    <div class="row mt-3 mx-0" v-if="recordScreenHelpView">
      <div class="col-12">
        <div class="panel">
          <div class="image">
            <img src="../../assets/record-screen-help-view.svg" />
          </div>
          <div class="detail">
            <h5 class="title">Choose what you’d like to screenshot:</h5>
            <p class="subtitle text-left">
              Steps for Chrome Browser: Steps for Chrome Browser: <br /><br />
              STEP 1. Select Entire Screen, Window, or Browser Tab.
              <br /><br />
              STEP 2. Click the screen you want to share. After this, the Share button will become clickable.
              <br /><br />
              STEP 3. Click the Share button.
            </p>
            <button class="btn btn-solid" @click="takeScreenshot">
              <div class="icon">
                <svg width="16" height="17" viewBox="0 0 16 17" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6.0001 11.5406L3.2201 8.76064L2.27344 9.70064L6.0001 13.4273L14.0001 5.4273L13.0601 4.4873L6.0001 11.5406Z" />
                </svg>
              </div>
              I Understand. Continue
            </button>
            <canvas id="fake" style="display:none"></canvas>
          </div>
        </div>
      </div>
    </div>
    <div v-if="captureImagePath">
      <DokaEditor :image="captureImagePath" @dockaImageSubmit="dockaImageSubmit" @retakeDokaImage="retakeDokaImage"></DokaEditor>
    </div>
    <div class="row mt-3 mx-0">
      <div class="col-12">
        <button class="back-btn d-flex align-items-center p-0 border-0" @click="backScreenClick">
          <div class="icon">
            <img src="../../assets/angle-left.svg" alt="" />
          </div>
          <div class="text">
            <p class="mb-0">Back</p>
          </div>
        </button>
        <div class="d-flex align-items-center justify-content-center">
          <Branding></Branding>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import RecordRTC from "recordrtc";
const takeScreenShotClick = async (stream) => {
  // get correct video track
  const track = stream.getVideoTracks()[0];
  // init Image Capture and not Video stream
  const imageCapture = new ImageCapture(track);
  // take first frame only
  const bitmap = await imageCapture.grabFrame();
  // destory video track to prevent more recording / mem leak
  track.stop();
  const canvas = document.getElementById("fake");
  // this could be a document.createElement('canvas') if you want
  // draw weird image type to canvas so we can get a useful image
  canvas.width = bitmap.width;
  canvas.height = bitmap.height;
  const context = canvas.getContext("2d");
  context.drawImage(bitmap, 0, 0, bitmap.width, bitmap.height);
  const image = canvas.toDataURL();
  return image;
};

import DokaEditor from "./../DokaEditor";
import Branding from "./branding.vue";

// import $ from "jquery";
// import FFmpegjsEngine from 'videojs-record/dist/plugins/videojs.record.ffmpegjs.js';
export default {
  props: ["uploadUrl"],
  components: {
    // recorder,
    DokaEditor,
    Branding
  },
  data() {
    return {
      cameraAccessPermission: false,
      popUpPermission: false,
      accessPopUpView: false,
      grandAccessPermissionView: false,
      recordScreenInputsCheck: false,
      recorder: null,
      recordScreenHelpView: false,
      recorderStartTime: null,
      recordWebCamVideo: false,
      selectedRecordWebCamClick: false,
      inputDevices: [],
      cameraStream: null,
      stream: null,
      capture: null,
      captureImageView: false,
      takeImageView: true,
      captureImagePath: null,
    };
  },
  created() {
    setTimeout(() => {
      this.$helpers.updateColorAccordingApi();
    });
    this.checkCameraAccess();
    this.inputDevicesData();
  },
  mounted() {
    this.$helpers.updateColorAccordingApi();
  },
  methods: {
    grantAccessCamera() {
      this.accessPopUpView = true;
      this.grandAccessPermissionView = false;
      if (!this.cameraAccessPermission) {
        navigator.mediaDevices
          .getUserMedia({ audio: false, video: true })
          .then(() => {
            this.cameraAccessPermission = true;
          })
          .catch(function() {});
      }
    },
    backScreenClick() {
      this.$emit("backFromTakeWebCam");
    },
    checkCameraAccess() {
      navigator.permissions.query({ name: "camera" }).then((res) => {
        if (res.state == "granted") {
          this.recordScreenHelpView = true;
        } else {
          this.grandAccessPermissionView = true;
        }
        res.onchange = (e) => {
          // detecting if the event is a change
          if (e.type === "change") {
            // checking what the new permissionStatus state is
            const newState = e.target.state;
            if (newState === "denied") {
              console.log("why did you decide to block us?");
            } else if (newState === "granted") {
              this.recordScreenHelpView = true;
            } else {
              console.log("Thanks for reverting things back to normal");
            }
          }
        };
      });
    },
    inputDevicesData() {
      navigator.mediaDevices
        .enumerateDevices()
        .then((devices) => {
          devices.forEach((device) => {
            this.inputDevices.push(device);
            console.log(device.kind + ": " + device.label + " id = " + device.deviceId);
          });
        })
        .catch(function(err) {
          console.log(err.name + ": " + err.message);
        });
    },
    filterDevices(deviceKind) {
      let audioDevices = this.inputDevices.filter((el) => {
        return el.kind == deviceKind;
      });
      return audioDevices;
    },
    async takeScreenshot() {
      const stream = await navigator.mediaDevices.getDisplayMedia({
        video: { mediaSource: "screen" },
      });
      setTimeout(async () => {
        let takeImagefile = await takeScreenShotClick(stream);
        if (takeImagefile) {
          this.captureImagePath = takeImagefile;
          this.recordScreenHelpView = false;
        }
      }, 1000);
    },
    dockaImageSubmit(image) {
      this.$emit("savedTakeScreenShotImage", image);
    },
    retakeDokaImage() {
      this.recordScreenHelpView = true;
      this.captureImagePath = false;
    },
  },
};
</script>
<style scoped lang="scss">
.feedback-header {
  border-radius: 5px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;

  p {
    font-family: "Poppins", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 24px;
    text-align: center;
    letter-spacing: 0.01em;
    color: var(--title-color);
    margin: 0;
    margin-left: 8px;
  }
}
.detail {
  margin-top: 16px;
  .title {
    font-family: Poppins;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    letter-spacing: 0.01em;
    color: #313c4e;
    margin-bottom: 16px;
  }
  .subtitle {
    font-family: Poppins;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 18px;
    text-align: center;
    letter-spacing: 0.01em;
    color: #56657f;
    margin-bottom: 0px;
  }

  .btn {
    width: 100%;
    height: 50px;
    margin-top: 32px;
  }
}
.back-btn {
  margin-bottom: 35px;
  background: none;
  .icon {
    margin-right: 8px;
  }
  .text {
    p {
      font-family: "Poppins", sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 13px;
      line-height: 20px;
      letter-spacing: 0.01em;
      color: #56657f;
    }
  }
}
.copyright {
  display: flex;
  align-items: flex-end;
  margin-bottom: 15px;
  padding: 4px 11px;
  background: #fff;
  margin-bottom: 15px;
  border-radius: 40px;
  .icon {
    margin-right: 4.84px;
    display: flex;
    align-items: flex-end;
    padding-bottom: 3px;
  }
  .text {
    p {
      font-family: "Mulish", sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 10px;
      line-height: 15px;
      color: #8997b1;
    }
  }
}
a {
  text-decoration: none;
}
.form-options {
  .form-option {
    margin-top: 32px;
    .label {
      font-family: Poppins;
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      line-height: 18px;
      display: flex;
      align-items: center;
      letter-spacing: 0.01em;
      color: #8997b1;

      .icon {
        margin-right: 8px;
      }
    }
    .dropdown {
      .dropdown-toggle {
        height: 42px;
        background: #fcfdfe;
        border: 1px solid #ebedf0;
        border-radius: 4px;
        font-family: Poppins;
        font-style: normal;
        font-weight: 500;
        font-size: 11px;
        line-height: 16px;
        letter-spacing: 0.01em;
        color: #8997b1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0px 16px;
        margin-top: 15px;
      }
      .dropdown-menu {
        margin: 0;
        width: 100%;
        padding: 0;
        border-top-left-radius: 0;
        border-top-right-radius: 0;

        .dropdown-item {
          font-family: Poppins;
          font-style: normal;
          font-weight: 500;
          font-size: 11px;
          line-height: 16px;
          letter-spacing: 0.01em;
          color: #8997b1;
          padding: 0.25rem 16px;
        }
      }
    }
    .mic-check {
      margin-top: 8px;

      .progress {
        width: 100px;
        height: 9px;
        background-color: #f1f2f9;
        border-radius: 4px;

        .progress-bar {
          background-color: var(--accent-color);
          border-radius: 4px;
        }
      }
    }
  }
}
.title-head {
  font-family: Poppins;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  letter-spacing: 0.01em;
  color: var(--accent-color);
  margin-bottom: 16px;

  .icon {
    margin-right: 4px;
  }
}
.recording-video-access {
  // max-width: 420px;
  width: 100%;
  margin: auto;
}
.btn-solid {
  font-family: "Poppins", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  letter-spacing: 0.01em;
  color: var(--action-btn-color) !important;
  background: var(--accent-color);
  width: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 35px;
  padding: 0 18px;
  border-radius: 5px;
  .icon {
    margin-right: 8px;
    fill: var(--action-btn-color);
  }
  &:hover {
    color: var(--action-btn-color);
  }
}
.options {
  .option-item {
    background: var(--accent-color);
    border-radius: 5px;
    width: 100%;
    height: 71px;
    margin-right: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: relative;
    cursor: pointer;

    input {
      position: absolute;
      top: 0;
      bottom: 0;
      right: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      cursor: pointer;
    }

    &:last-child {
      margin-right: 0px;
    }

    svg {
      margin-bottom: 6px;
    }
    .upload-style {
      font-family: "Poppins", sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      line-height: 18px;
      text-align: center;
      letter-spacing: 0.01em;
      color: #ffffff;
    }

    p {
      font-family: "Poppins", sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      line-height: 18px;
      text-align: center;
      letter-spacing: 0.01em;
      color: #ffffff;
    }
  }
}
</style>
